import React from "react";
import PropTypes from "prop-types";

import { collectionToStories } from "@quintype/components";

import { StoryCard } from "../../Molecules/StoryCard";
import { HeroImage } from "../../Atoms/HeroImage";
import { StorycardContent } from "../../Molecules/StorycardContent";
import { Button } from "../../../../components/atoms";
import { getSlug } from "../../../utils/utils";
import { TopRowAd } from "../../Molecules/TopRowAd";
import { getCategoryAndSubCategory } from "../../../../ga-utils";
import { getTemplateName } from "../../../../components/utils";

import "./top-row-component.m.css";

const storyCard = (story) => (
  <>
    <StorycardContent story={story} headerLevel={5} showSubHeadLine={false} showAuthorContent={false} />
    <HeroImage story={story} aspectRatio={[[16, 9]]} />
  </>
);

const firstcard = (story, handleClick) => (
  <div styleName="first-story-card" onClick={() => handleClick(0)}>
    <StoryCard
      story={story}
      headerLevel="2"
      aspectRatio={[
        [16, 9],
        [16, 9],
      ]}
      config={{}}
    />
  </div>
);

export const TopRowComponent = ({ collection, config }) => {
  const storyItems = collectionToStories(collection);
  if (storyItems.length < 1) {
    return null;
  }

  const handleClick = (position) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, "home-page");
      window.dataLayer.push({
        event: "dl_story_listing_component_click",
        link_position: position + 1,
        section_name: collection?.name?.toLowerCase(),
        category: category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName("home-page"),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  return (
    <div>
      <div className="full-width-with-padding arrow-component" styleName="main-wrapper" data-test-id="top-component">
        <div styleName="wrapper">
          {/* Desktop Layout */}
          <div>
            <div styleName="part row-desktop">
              {firstcard(storyItems[0], handleClick)}
              <div styleName="vertical-separator" />
              <div styleName="column">
                <div onClick={() => handleClick(1)}>
                  {" "}
                  <StoryCard
                    story={storyItems[1]}
                    headerLevel="5"
                    aspectRatio={[
                      [16, 9],
                      [16, 9],
                    ]}
                    config={{}}
                  />
                </div>

                <div styleName="horizontal-separator" />
                <div onClick={() => handleClick(2)}>
                  <StoryCard
                    story={storyItems[2]}
                    headerLevel="5"
                    aspectRatio={[
                      [16, 9],
                      [16, 9],
                    ]}
                    config={{}}
                  />
                </div>
              </div>
              <div styleName="vertical-separator" />
              <div styleName="column-2">
                <TopRowAd config={config} collection={collection} isDesktop={true} />
                <div onClick={() => handleClick(3)} styleName="top-row-story-below-ad">
                  <StoryCard
                    story={storyItems[3]}
                    headerLevel="5"
                    aspectRatio={[
                      [16, 9],
                      [16, 9],
                    ]}
                    config={{}}
                  />
                </div>
              </div>
            </div>
            <div styleName="row-mobile">
              {firstcard(storyItems[0])}
              <div styleName="horizontal-separator" />
              <TopRowAd config={config} collection={collection} isDesktop={false} />
              {storyItems.length > 1 && (
                <>
                  {storyItems.slice(1, 4).map((story, index) => {
                    return (
                      <>
                        <div styleName="horizontal-separator" />
                        <div styleName="storycard" key={story.id} onClick={() => handleClick(index)}>
                          {storyCard(story)}
                        </div>
                      </>
                    );
                  })}
                </>
              )}
            </div>
            {storyItems.length > 4 && (
              <>
                <div styleName="horizontal-separator" />
                <div styleName="part-2">
                  {storyItems.slice(4, 7).map((story, index) => {
                    return (
                      <>
                        <div styleName="storycard" key={story.id} onClick={() => handleClick(index)}>
                          {storyCard(story)}
                          {index + 1 !== storyItems.slice(4, 7).length && <div styleName="vertical-separator" />}
                        </div>
                        {index + 1 !== storyItems.slice(4, 7).length && <div styleName="horizontal-separator" />}
                      </>
                    );
                  })}
                </div>
              </>
            )}
            <div styleName="row-mobile read-more-button">
              <Button href={getSlug(collection, {})}>Read More</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TopRowComponent.propTypes = {
  collection: PropTypes.object,
};

export default TopRowComponent;

TopRowComponent.storyLimit = 7;
